import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { SuspensionRead } from '../../services/apiService';
import { formatToLocalTime } from '../../utils/dateUtils';
interface SuspensionDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  suspension: SuspensionRead | null;
  /** Nom du capteur à afficher. Si absent, utilise suspension.sensor_name ou #sensor_id. */
  sensorName?: string;
}

const formatDate = (dateStr: string, t: (key: string) => string): string =>
  formatToLocalTime(dateStr, {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  });

const SuspensionDeleteDialog: React.FC<SuspensionDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  suspension,
  sensorName,
}) => {
  const { t } = useTranslation();

  const displayName =
    sensorName ??
    suspension?.sensor_name ??
    (suspension ? `#${suspension.sensor_id}` : '');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('suspensions.delete.confirmTitle')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('suspensions.delete.confirmBody', {
            sensor: displayName,
            start: suspension ? formatDate(suspension.start_at, t) : '',
            end:   suspension
              ? suspension.is_indefinite
                ? t('suspensions.indefinite')
                : formatDate(suspension.end_at, t)
              : '',
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? <CircularProgress size={18} /> : t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuspensionDeleteDialog;
